import { IWebsiteInfo } from "./i-web-site-info";

export const webSiteInfo : IWebsiteInfo = {
  name: 'dixie-parts-centre',
  id: 'dpc'
};